export const DRAWER_MENU_LABEL = {
  DASHBOARD: 'DASHBOARD',
  MASTER: 'MASTER',
  USER_MASTER: 'USER_MASTER',
  USER_STATE_PENDING: 'USER_STATE_PENDING',
  USER_ADMIN_PENDING: 'USER_ADMIN_PENDING',
  CATEGORY_MASTER: 'CATEGORY_MASTER',
  SUB_CATEGORY_MASTER: 'SUB_CATEGORY_MASTER',
  DEPARTMENT_MASTER: 'DEPARTMENT_MASTER',
  DESIGNATION_MASTER: 'DESIGNATION_MASTER',
  COMPLAINT_ASSIGNMENT: 'COMPLAINT_ASSIGNMENT',
  COMPLAINT_VIEW: 'COMPLAINT_VIEW',
  COMPLAINT_VIEW_EDIT: 'COMPLAINT_VIEW_EDIT',
  POSITIVE_FEEDBACK: 'POSITIVE_FEEDBACK',
  LATEST_UPDATE: 'LATEST_UPDATE',
  GUIDELINES_CIRCULARS: 'GUIDELINES_CIRCULARS',
  REPORT: 'REPORT',

  KANBAN: 'KANBAN',
  USERS: 'USERS',
  PLAY_BACKGROUND: 'PLAY_BACKGROUND',

  PRODUCT: 'MASTER',
  PRODUCT_ADD: 'PRODUCT_ADD',
  PRODUCT_LIST: 'PRODUCT_LIST',

  EVENT: 'EVENT',
  INFORMATION: 'INFORMATION',
  SCHEMES: 'SCHEMES',
  OPPORTUNITY: 'OPPORTUNITY',
  USER_OPPORTUNITIES: 'USER_OPPORTUNITIES',
  RESOURCES: 'RESOURCES',
  HELPLINES: 'HELPLINES',
  NOTIFICATIONS: 'NOTIFICATIONS',

  COMPLAINT_REASSIGNMENT_LIST: 'COMPLAINT_REASSIGNMENT_LIST',

  FEEDBACK_FORM: 'FEEDBACK',
};
